<script setup>
import Sidebar from "/app/layouts/partials/Sidebar.vue";
import NBreadcrumbs from '/app/components/NBreadcrumbs.vue';

const type = "boxed";

defineExpose({ type });
</script>

<template>
	<div class="container mx-auto pt-3">
		<div class="grid grid-cols-12 gap-4 game-dash-row">
			<div class="col-span-12 game-dash-row__breadcrumb">
				<NBreadcrumbs />
			</div>
		</div>
		<div class="custom-page-row grid grid-cols-1 sm:grid-cols-12 gap-6 sm:4">
			<div class="sm:col-span-4 md:col-span-3 lg:col-span-2">
				<Sidebar />
			</div>
			<div class="sm:col-span-8 md:col-span-9 lg:col-span-10">
				<RouterView v-slot="{ Component }">
					<template v-if="Component">
						<component :is="Component" />
					</template>
					<div v-else class="w-full h-screen bg-dust-50 rounded-md flex items-center justify-center animate-pulse" />
				</RouterView>
			</div>
		</div>
	</div>
</template>
